/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  AbstractSnapshotFormComponent,
  FormState,
  FormStateBuilder,
  FormStateSnapshot,
} from '@gh/common-shared';
import { DrawRuleMasterInfo } from '../../../resources/draw-rule-details.model';

@Component({
  standalone: false,
  selector: 'gh-draw-rule-details-top-form',
  templateUrl: 'draw-rule-details-top-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawRuleDetailsTopFormComponent extends AbstractSnapshotFormComponent<DrawRuleMasterInfo> {

  constructor(private formStateBuilder: FormStateBuilder) {
    super();
  }

  protected buildForm(snapshot: FormStateSnapshot<DrawRuleMasterInfo>): FormState<DrawRuleMasterInfo> {
    return this.formStateBuilder.buildPlain({
      enabled: this.enabled,
      snapshot,
      children: {
        code: { required: void 0 },
        name: { required: void 0 },
        basis: { required: void 0 },
        isNotProceeding: {},
      },
    });
  }
}
